import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
} from 'react-native';
// import { Auth } from '@aws-amplify/auth';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import { AppSyncClientAuthenticated } from '../../../backends/AppSyncClient';
import { AppSyncClientCreate } from '../../../backends/AppSyncClientCreate';
import AddApp from '../../../q/create/AddApp';
import GetMyApp from '../../../q/create/GetMyApp';
import GetMyApps from '../../../q/create/GetMyApps';
import ChangeAppApp from '../../../q/create/ChangeAppApp';
import ChangeAppGuide from '../../../q/create/ChangeAppGuide';
import ChangeAppLocation from '../../../q/create/ChangeAppLocation';
import ChangeAppPrice from '../../../q/create/ChangeAppPrice';
import ChangeAppLinks from '../../../q/create/ChangeAppLinks';
import ChangeAppReview from '../../../q/create/ChangeAppReview';
import PreviewApp from '../../../q/create/PreviewApp';
import PublishApp from '../../../q/create/PublishApp';
import GetUser from '../../../q/GetUser';
import AddUserImage from '../../../q/AddUserImage';
import App from '../../../modules/data/App';
import PublisherAppFormApp from '../../../components/forms/app/Page1App';
import PublisherAppFormGuide from '../../../components/forms/app/Page2Guide';
import PublisherAppFormEndpoints from '../../../components/forms/app/Page3Endpoints';
import PublisherAppFormFinancial from '../../../components/forms/app/Page4Financial';
import PublisherAppFormLinks from '../../../components/forms/app/Page5Links';
import PublisherAppFormReview from '../../../components/forms/app/Page6Review';

import { currency } from '../../../money';
import AORTypes from '../../../types';

import styles from '../../../styles';
import { translate } from '../../../locales/i18n';
import withContext from '../../../context';

class PublisherAppAdd extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.displayName = 'PublisherAppAdd';

    this.onPageSwitch = this.onPageSwitch.bind(this);
    this.onPage1Save = this.onPage1Save.bind(this);
    this.onPage2Save = this.onPage2Save.bind(this);
    this.onPage3Save = this.onPage3Save.bind(this);
    this.onPage4Save = this.onPage4Save.bind(this);
    this.onPage5Save = this.onPage5Save.bind(this);
    this.onPage6Save = this.onPage6Save.bind(this);
    this.onPage6SavePreview = this.onPage6SavePreview.bind(this);
    this.onPage6SavePublish = this.onPage6SavePublish.bind(this);
    this.onGoBackToApps = this.onGoBackToApps.bind(this);

    this.state = {
      app: null,
      page: 1,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    console.log('getDerivedStateFromProps() called');

    const { user } = nextProps;
    const { app } = prevState;

    if (app || !user) {
      return null;
    }

    console.log('creating a app from user');
    return {
      app: (new App()).createFromUser(user),
    };
  }

  onPageSwitch(page) {
    const { context, history } = this.props;
    const { uuid } = this.state;

    // this.setState({ page });
    if (!uuid) {
      console.log('Not yet added this app');
      return;
    }

    context.createAppPage[uuid] = page;
    history.push(`/editapp/${uuid}/${page}`);
  }

  async onPage1Save(values) {
    const { onPage1Save } = this.props;
    const { app, uuid } = this.state;

    app.data.lang = values.lang;
    app.data.name = values.appName;
    app.data.desc = values.appDesc;

    if (!uuid) {
      return this.addApp(onPage1Save);
    }

    return onPage1Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 2');
        console.log(err.message);
        return err.message;
      });
  }

  async onPage2Save(values) {
    const {
      user, userData, onUpdateUser, onPage2Save,
    } = this.props;
    const { app, uuid } = this.state;

    const { uuid: uuidUser, image } = userData;
    let { langs } = userData;
    const name = values.guideName;
    let descObj = {};
    try {
      descObj = JSON.parse(userData.desc);
    } catch (error) {
      console.log('failed parsing the app description');
      console.log(error);
    }
    if (descObj !== null) {
      descObj[app.data.lang] = values.guideDesc;
    } else {
      descObj = {};
    }
    const desc = JSON.stringify(descObj);

    app.data.guideName = values.guideName;
    app.data.guideDesc = values.guideDesc;
    app.data.guideImage = image;

    try {
      const langsObj = JSON.parse(langs);
      if (!langsObj.includes(app.data.lang)) {
        langsObj.push(app.data.lang);
      }
      langs = JSON.stringify(langsObj);
    } catch (error) {
      console.log('failed parsing the user languages');
    }

    return Auth.updateUserAttributes(user, {
      preferred_username: name,
    })
      .then(async () => {
        user.attributes.preferred_username = name;
        await Auth.currentAuthenticatedUser({ bypassCache: true });

        return onUpdateUser({
          uuid: uuidUser, name, desc, image, langs,
        })
          .then(() => {
            console.log('done updating the user, now updating the app');
            // updateUserData();

            if (!uuid) {
              return this.addApp(onPage2Save);
            }

            return onPage2Save(app)
              .then(() => null)
              .catch((err) => {
                console.log('failed to save the page 2');
                console.log(err.message);
                return err.message;
              });
          })
          .catch((err) => {
            console.log('error in onUpdateUser');
            console.log(err);
            return err.message;
          });
      })
      .catch((err) => {
        let error = err.message;
        if (err.code === 'AliasExistsException') {
          error = translate('create_app_guide_exists');
        }
        return error;
      });
  }

  async onPage3Save(values) {
    const { onPage3Save } = this.props;
    const { app, uuid } = this.state;

    app.data.travelType = values.travelType;
    app.data.endpointIds = values.endpointIds;
    app.data.bounds = values.bounds;
    app.data.legs = values.legs;
    app.data.route = values.route;
    app.data.routeduration = values.routeduration;
    app.data.routelen = values.routelen;

    if (!uuid) {
      return this.addApp(onPage3Save);
    }

    return onPage3Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 3');
        console.log(err.message);
        return err.message;
      });
  }

  async onPage4Save(values) {
    const { onPage4Save } = this.props;
    const { app, uuid } = this.state;

    app.data.type = values.type;
    app.data.currency = currency;
    app.data.rentPrice = values.rentPrice;
    app.data.rentDays = values.rentDays;
    app.data.buyPrice = values.buyPrice;

    if (!uuid) {
      return this.addApp(onPage4Save);
    }

    return onPage4Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 4');
        console.log(err.message);
        return err.message;
      });
  }

  async onPage5Save(values) {
    const { onPage5Save } = this.props;
    const { app, uuid } = this.state;

    app.data.linkWeb = values.web;
    app.data.linkYoutube = values.youtube;
    app.data.linkFacebook = values.facebook;
    app.data.linkInstagram = values.instagram;
    app.data.linkTwitter = values.twitter;

    if (!uuid) {
      return this.addApp(onPage5Save);
    }

    return onPage5Save(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to save the page 5');
        console.log(err.message);
        return err.message;
      });
  }

  async onPage6Save(values) {
    const { onPage6Save } = this.props;
    const { app, uuid } = this.state;

    app.data.promoted = values.promoted;

    if (!uuid) {
      return this.addApp(onPage6Save);
    }

    return onPage6Save(app)
      .then(() => {
        console.log('publishing...');
        return null;
      })
      .catch((err) => {
        console.log('failed to save the page 6');
        console.log(err.message);
        return err.message;
      });
  }

  onPage6SavePreview(values) {
    const { onPage6SavePreview } = this.props;
    const { app } = this.state;

    app.data.promoted = values.promoted;

    return onPage6SavePreview(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to preview');
        console.log(err.message);
        return err.message;
      });
  }

  onPage6SavePublish(values) {
    const { onPage6SavePublish } = this.props;
    const { app } = this.state;

    app.data.promoted = values.promoted;

    return onPage6SavePublish(app)
      .then(() => null)
      .catch((err) => {
        console.log('failed to publish');
        console.log(err.message);
        return err.message;
      });
  }

  async onGoBackToApps() {
    const { user, history, onDelete } = this.props;
    const { uuid } = this.state;
    if (!uuid) {
      // FIXME(clairbee): prompt the user whether to delete or to save for later if uuid is known
      onDelete(uuid);
    }

    history.push(`/publisher/${user.attributes.sub}`);
  }

  async addApp(func) {
    const { onAdd } = this.props;
    const { app } = this.state;

    return onAdd(app).then((result) => {
      console.log(`added result: ${result}`);
      console.log(`added result.data: ${result.data}`);
      console.log(`added result.data.createApps: ${result.data.createApps}`);
      console.log(`added uuid: ${result.data.createApps.uuid}`);
      app.data.uuid = result.data.createApps.uuid;

      this.setState({
        uuid: result.data.createApps.uuid,
      });

      const ret = func(app);
      if (ret === null) {
        return null;
      }

      return ret
        .then(() => null)
        .catch((err) => {
          console.log('failed to add app');
          console.log(err.message);
          return err.message;
        });
    });
  }

  render() {
    const {
      direction, history, user, onRefresh, userData, updateUserData, getUploader, getDirectionsService,
      onAddUserImage,
      getAnalyticsService,
    } = this.props;
    const { app, page } = this.state;

    if (!app || !userData) {
      return (
        <>
        </>
      );
    }

    return (
      <View style={styles.view.headed}>
        <View style={styles.view.form}>
          {/* Bredcrumbs is not here because it needs to know if the form is dirty  */}
          {page === 1 && (
            <PublisherAppFormApp
              app={app}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage1Save}
              getAnalyticsService={getAnalyticsService}
            />
          )}
          {page === 2 && (
            <PublisherAppFormGuide
              user={user}
              userData={userData}
              onAddUserImage={onAddUserImage}
              updateUserData={updateUserData}
              app={app}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage2Save}
              getUploader={getUploader}
              getAnalyticsService={getAnalyticsService}
            />
          )}
          {page === 3 && (
            <PublisherAppFormEndpoints
              app={app}
              direction={direction}
              history={history}
              getDirectionsService={getDirectionsService}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage3Save}
              onRefresh={onRefresh}
              getAnalyticsService={getAnalyticsService}
            />
          )}
          {page === 4 && (
            <PublisherAppFormFinancial
              app={app}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage4Save}
              getAnalyticsService={getAnalyticsService}
              direction={direction}
            />
          )}
          {page === 5 && (
            <PublisherAppFormLinks
              app={app}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage5Save}
              getAnalyticsService={getAnalyticsService}
              direction={direction}
            />
          )}
          {page === 6 && (
            <PublisherAppFormReview
              app={app}
              history={history}
              onCancel={this.onGoBackToApps}
              onPageSwitch={this.onPageSwitch}
              onSave={this.onPage6Save}
              onSavePreview={this.onPage6SavePreview}
              onSavePublish={this.onPage6SavePublish}
              getAnalyticsService={getAnalyticsService}
            />
          )}
        </View>
      </View>
    );
  }
}

PublisherAppAdd.defaultProps = {
  onDelete: () => { },
  onRefresh: () => { },
  user: null,
  userData: null,
};

PublisherAppAdd.propTypes = {
  context: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  updateUserData: PropTypes.func.isRequired,
  onUpdateUser: PropTypes.func.isRequired,
  onAddUserImage: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  getUploader: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onPage1Save: PropTypes.func.isRequired,
  onPage2Save: PropTypes.func.isRequired,
  onPage3Save: PropTypes.func.isRequired,
  onPage4Save: PropTypes.func.isRequired,
  onPage5Save: PropTypes.func.isRequired,
  onPage6Save: PropTypes.func.isRequired,
  onPage6SavePreview: PropTypes.func.isRequired,
  onPage6SavePublish: PropTypes.func.isRequired,
  onRefresh: PropTypes.func,
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User,
  getDirectionsService: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
};

const changeOptions = (props) => ({
  refetchQueries: [
    ...(props.app && props.app.data.uuid !== undefined ? [{
      query: GetMyApp,
      variables: { uuid: props.app.data.uuid },
      client: AppSyncClientCreate(props.user),
    }] : []),
    {
      query: GetMyApps,
      client: AppSyncClientCreate(props.user),
    },
  ],
  client: AppSyncClientCreate(props.user),
});

export default compose(
  graphql(AddUserImage, {
    // name: 'AddEndpointImage',
    props: (props) => ({
      onAddUserImage: ({
        uuid, name, isVertical, lat, lon, type,
      }) => props.mutate({
        variables: {
          uuid,
          name,
          isVertical,
          lat,
          lon,
          type,
        },
        // TODO(clairbee): optimisticResponse breaks refetchQueries
        // optimisticResponse: () => ({
        //   updateEndpoint:
        //     endpoint.makeOptimistic().output(),
        // }),
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetUser,
        variables: { uuid: props.user && props.user.attributes.sub },
        client: AppSyncClientAuthenticated(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  }),
  graphql(AddApp, {
    props: (props) => ({
      onAdd: (app) => props.mutate({
        variables: app.output(),
        optimisticResponse: () => ({
          createApps:
            app.makeOptimistic().output(),
          // TODO(clairbee): do we need optimistic response for GetMyApps instead? in addition?
        }),
      }),
      // onDelete: app => props.mutate({
      //   ...
      // })
      // onPage1Save: app => props.mutate({
      //   query: UpdadeMyApps,
      //   // variables: (params) => {
      // })
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetMyApps,
        // variables: (params) => {
        //   console.log("props");
        //   console.log(props);
        //   console.log("params");
        //   console.log(params);
        //   return { uuid: props.uuid };
        // },
        client: AppSyncClientCreate(props.user),
      }],
      // update: (dataProxy, { data: { createApps } }) => {
      //   const query = GetMyApp;
      //   const data = dataProxy.readQuery({ query });

      //   // data.getApps.push(app.data);
      //   console.log("createApps");
      //   console.log(createApps);
      //   console.log("data");
      //   console.log(data);
      //   data.getApps.push(createApps);

      //   console.log(data);
      //   dataProxy.writeQuery({ query, data });
      // },
      /* fetchPolicy: 'cache-and-network' */
      client: AppSyncClientCreate(props.user),
    }),
  }),
  graphql(ChangeAppApp, {
    props: ({ mutate }) => ({
      onPage1Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          lang: app.data.lang,
          name: app.data.name,
          desc: app.data.desc,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppGuide, {
    props: ({ mutate }) => ({
      onPage2Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          guideName: app.data.guideName,
          guideDesc: app.data.guideDesc,
          guideImage: app.data.guideImage,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppLocation, {
    props: ({ mutate }) => ({
      onPage3Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          travelType: app.data.travelType,
          endpointIds: app.data.endpointIds,
          lat: app.data.lat,
          lon: app.data.lon,
          coords: app.data.coords,
          bounds: app.data.bounds,
          route: app.data.route,
          legs: app.data.legs,
          routeduration: app.data.routeduration,
          routelen: app.data.routelen,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppPrice, {
    props: ({ mutate }) => ({
      onPage4Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          type: app.data.type,
          currency: app.data.currency,
          rentPrice: app.data.rentPrice,
          rentDays: app.data.rentDays,
          buyPrice: app.data.buyPrice,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppLinks, {
    props: ({ mutate }) => ({
      onPage5Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          linkWeb: app.data.linkWeb,
          linkYoutube: app.data.linkYoutube,
          linkFacebook: app.data.linkFacebook,
          linkInstagram: app.data.linkInstagram,
          linkTwitter: app.data.linkTwitter,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(ChangeAppReview, {
    props: ({ mutate }) => ({
      onPage6Save: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
          promoted: app.data.promoted,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(PreviewApp, {
    props: ({ mutate }) => ({
      onPage6SavePreview: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
        },
      }),
    }),
    options: changeOptions,
  }),
  graphql(PublishApp, {
    props: ({ mutate }) => ({
      onPage6SavePublish: (app) => mutate({
        variables: {
          uuid: app.data.uuid,
        },
      }),
    }),
    options: changeOptions,
  })
)(withContext(PublisherAppAdd));
